import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

export default function LoginPage() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user && user.id) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const loggedInUser = await login(email, password);
    setBusy(false);
    if (loggedInUser) navigate(loggedInUser.role === "admin" ? "/admin" : "/portal");
  };

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50 flex items-center" data-testid="login-page">
      <div className="mbw-container max-w-md mx-auto w-full">
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-slate-200 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-14 h-14 rounded-xl bg-[#1A2433] flex items-center justify-center mx-auto mb-4">
              <LogIn className="w-7 h-7 text-[#991B1B]" />
            </div>
            <h1 className="font-heading text-3xl font-bold text-[#1A2433] mb-2">Kundenportal Login</h1>
            <p className="text-slate-600 text-sm">Willkommen zurück bei MBW Swiss.</p>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium text-[#1A2433] mb-2">E-Mail</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#991B1B]"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1A2433] mb-2">Passwort</label>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#991B1B]"
                data-testid="login-password-input"
              />
            </div>
            {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-md" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="login-submit-btn">
              {busy ? "Anmelden…" : "Anmelden"}
            </button>
          </form>

          <div className="text-center text-sm text-slate-600 mt-6">
            Noch kein Konto? <Link to="/register" className="font-semibold text-[#1A2433] hover:text-[#991B1B]" data-testid="goto-register">Jetzt registrieren</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
